export const pageToPath: Record<string, string> = {
  home: "/",
  login: "/login",
  register: "/register",
  "verify-email": "/verify-email",
  "reset-password": "/reset-password",
  "email-change-info": "/email-change-info",
  "verify-account": "/verify-account",
  search: "/search",
  categories: "/categories",
  account: "/account",
  statistics: "/statistics",
  admin: "/admin",
  "suggest-website": "/suggest-website",
  "manage-websites": "/manage-websites",
  "manage-languages": "/manage-languages",
  impressum: "/legal-notice",
  datenschutz: "/privacy",
  nutzungsbedingungen: "/terms-of-service",
  hilfe: "/help",
  error: "/error",
  "error-404": "/error/404",
  "error-403": "/error/403",
  "error-500": "/error/500",
  "error-maintenance": "/error/maintenance",
};

const pathToPageMap = new Map<string, string>(
  Object.entries(pageToPath).map(([page, path]) => [path, page])
);

const legacyPathToPageMap = new Map<string, string>([
  ["/impressum", "impressum"],
  ["/datenschutz", "datenschutz"],
  ["/nutzungsbedingungen", "nutzungsbedingungen"],
  ["/hilfe", "hilfe"],
]);

export const normalizePathname = (pathname: string) => {
  if (!pathname) return "/";
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
};

export const getPageFromPath = (pathname: string): string => {
  const normalized = normalizePathname(pathname);
  if (normalized === "/") {
    return "home";
  }
  return (
    pathToPageMap.get(normalized) ??
    legacyPathToPageMap.get(normalized) ??
    "error"
  );
};
